import { useAppSelector } from "@/hooks/use-state";
import { selectAuthLoading } from "@/features/auth/authSlice";
import logoIRB from "@/assets/images/irb-logo_home.svg";

export default function HomePage() {
  const isLoadingAuth = useAppSelector(selectAuthLoading);
  const isLoading = isLoadingAuth;

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="bg-transparent text-[var(--color-primary)] h-full">
      {/* Header con Logo */}
      <div className="flex items-center justify-center h-full  py-16">
        <div className="container mx-auto px-6 text-center">
          <div className="flex justify-center mb-6">
            <div className="rounded-lg p-4">
              <img 
                src={logoIRB}
                alt="IRB Gestión" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <h1 className="text-4xl font-bold mb-4">
            Sistema de Gestión de Almacén
          </h1>
          <p className="text-xl max-w-2xl mx-auto">
            Plataforma integral para la gestión y control de inventarios, 
            optimización de espacios y administración de cadena de suministro
          </p>
        </div>
      </div>
    </div>
  );
}